import { X } from "lucide-react";

interface CloseButtonProps {
  href?: string;
}

export function CloseButton({ href }: CloseButtonProps) {
  if (!href) return null;

  return (
    <button
      type="button"
      aria-label="Avbryt"
      className="absolute top-3 right-3 p-1 w-7 h-7 hover:text-gray-600 hover:bg-gray-100 hover:cursor-pointer"
      onClick={() => {
        window.location.href = href;
      }}
    >
      <X size={20} />
    </button>
  );
}
